export const MODULE_NEWSLETTER_EMAILS = 'newsletter_emails';

export default {
  MODULE_NEWSLETTER_EMAILS,
};
